import { render } from "./pos-shift.vue?vue&type=template&id=568cb6c4"
import script from "./pos-shift.vue?vue&type=script&lang=js"
export * from "./pos-shift.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__